import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ReactElement, ReactNode } from 'react';
import { Modal, TaskBar } from '.';
import { Button, ButtonProps } from './Button';
import { ModalProps } from './Modal';

type ConfirmProps = ModalProps & {
  title?: string;
  message?: string;
  children?: ReactNode;
  confirmButton?: ButtonProps;
  cancelButton?: ButtonProps;
  onConfirm?: () => void;
  onClose?: () => void;
};

export function Confirm({
  title = '',
  message,
  children,
  confirmButton = {},
  cancelButton = {},
  onConfirm,
  onClose,
  ...props
}: ConfirmProps): ReactElement {
  return (
    <Modal
      show={!!props?.show}
      closable={props?.closable}
      dismissable={props?.dismissable}
      onClose={onClose}
      small
    >
      <h2>{title}</h2>
      {message && <p>{message}</p>}
      {children}
      <TaskBar
        right={
          <>
            <Button
              intent={cancelButton?.intent}
              label={cancelButton?.label ?? 'Cancel'}
              icon={cancelButton?.icon ?? faTimes}
              onClick={onClose}
              secondary
            />
            <Button
              intent={confirmButton?.intent}
              label={confirmButton?.label ?? 'Confirm'}
              icon={confirmButton?.icon}
              onClick={() => {
                onConfirm?.();
                onClose?.();
              }}
            />
          </>
        }
        background={false}
      />
    </Modal>
  );
}
